// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern AI-Style Course Module Page */

.courseModuleMainDiv {
    min-height: calc(100vh - 80px);
    padding: 40px 60px;
    background: #ffffff;
    position: relative;
    margin-top: 60px;
}

.disabledModule {
  filter: grayscale(100%);
  opacity: 0.45;
  pointer-events: none; /* block click & expand */
  border: 1px solid #d3d3d3;
}

.comingSoonText {
  margin-left: auto;
  font-size: 12px;
  color: #999;
  font-style: italic;
  background: rgba(255, 255, 255, 0.4);
  padding: 3px 8px;
  border-radius: 6px;
}


/* Breadcrumb Navigation */
.courseBreadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 30px;
    font-size: 14px;
    position: relative;
    z-index: 1;
}

.breadcrumbLink {
    color: #667eea;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    text-decoration: none;
    padding: 4px 8px;
    border-radius: 6px;
}

.breadcrumbLink:hover {
    color: #764ba2;
    background: rgba(102, 126, 234, 0.1);
    transform: translateY(-1px);
}

.breadcrumbCurrent {
    color: #6b7280;
    font-weight: 400;
}

.breadcrumbArrow {
    font-size: 12px !important;
    color: #9ca3af !important;
}

/* Loader */
.courseLoader {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    position: relative;
    z-index: 1;
}

/* Course Header */
.courseHeader {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 40px;
    position: relative;
    z-index: 1;
    animation: fadeInUp 0.6s ease-out;
}

.courseIconWrapper {
    width: 80px;
    height: 80px;
    background: rgba(102, 126, 234, 0.1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(102, 126, 234, 0.2);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    flex-shrink: 0;
    transition: all 0.3s ease;
}

.courseIconWrapper:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
}

.courseHeaderIcon {
    font-size: 40px !important;
    color: #667eea !important;
}

.courseHeaderContent {
    flex: 1 1;
}

.courseTitle {
    font-size: 42px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 12px 0;
    line-height: 1.2;
    letter-spacing: -0.5px;
}

.courseSubtitle {
    font-size: 16px;
    color: #6b7280;
    margin: 0;
    line-height: 1.6;
    font-weight: 400;
}

/* Section Headers */
.courseModulesSection,
.assessmentSection {
    margin-bottom: 40px;
    position: relative;
    z-index: 1;
    animation: fadeInUp 0.8s ease-out;
}

.sectionHeader {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
}

.sectionIcon {
    font-size: 28px !important;
    color: #667eea !important;
    background: rgba(102, 126, 234, 0.1);
    padding: 8px;
    border-radius: 10px;
    border: 1px solid rgba(102, 126, 234, 0.2);
}

.assessmentSectionIcon {
    background: rgba(245, 87, 108, 0.1) !important;
    border-color: rgba(245, 87, 108, 0.2) !important;
}

.sectionTitle {
    font-size: 28px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

/* Modern Accordion */
.modernAccordion {
    background: rgba(255, 255, 255, 0.95) !important;
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 16px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
    margin-bottom: 16px !important;
    overflow: hidden;
    transition: all 0.3s ease !important;
}

.modernAccordion:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

.modernAccordion::before {
    display: none !important;
}

.accordionSummary {
    padding: 20px 24px !important;
    min-height: 72px !important;
    transition: all 0.3s ease !important;
}

.accordionSummary .MuiAccordionSummary-content {
    margin: 12px 0 !important;
    overflow: visible !important;
}

.accordionSummary:hover {
    background: rgba(102, 126, 234, 0.05) !important;
}

.accordionHeaderContent {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    min-width: 0;
    flex: 1 1;
}

.partNumberBadge {
    width: 66px;
    height: 48px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 700;
    font-size: 18px;
    flex-shrink: 0;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    min-width: 48px;
}

.assessmentBadge {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;
    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4) !important;
}

.assessmentBadge svg {
    font-size: 24px !important;
}

.accordionHeadingWrapper {
    flex: 1 1;
    min-width: 0;
    display: flex;
    align-items: center;
}

.accordionHeading {
    margin: 0 !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #1f2937 !important;
    text-transform: none !important;
    overflow: visible;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.5;
    display: block;
    width: 100%;
}

.expandIcon {
    color: #667eea !important;
    font-size: 24px !important;
    transition: transform 0.3s ease !important;
}

.modernAccordion[aria-expanded="true"] .expandIcon {
    transform: rotate(180deg);
}

.accordionDetails {
    padding: 0 24px 24px 24px !important;
    background: rgba(255, 255, 255, 0.5) !important;
}

/* Course Source Div */
.courseSourceDiv {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* Course Item Card */
.courseItemCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: rgba(255, 255, 255, 0.8);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    border: 1px solid rgba(102, 126, 234, 0.2);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    gap: 16px;
}

.courseItemCard:hover {
    background: rgba(255, 255, 255, 0.95);
    transform: translateX(8px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
    border-color: rgba(102, 126, 234, 0.4);
}

.courseItemContent {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1 1;
    min-width: 0;
}

.courseItemIcon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.3s ease;
}

.videoIcon {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.documentIcon {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
}

.courseItemIcon svg {
    font-size: 24px !important;
    color: #ffffff !important;
}

.courseItemInfo {
    flex: 1 1;
    min-width: 0;
}

.courseItemName {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.courseItemMeta {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.courseItemTime {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
}

.timeIcon {
    font-size: 16px !important;
    color: #6b7280 !important;
}

.courseItemType {
    padding: 4px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.typeVideo {
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
}

.typeDocument {
    background: rgba(79, 172, 254, 0.1);
    color: #4facfe;
}

.courseItemProgress {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.completedIcon {
    position: absolute;
    font-size: 20px !important;
    color: #10b981 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* Assessment Item Card */
.assessmentItemCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: rgba(255, 255, 255, 0.8);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    border: 1px solid rgba(245, 87, 108, 0.2);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    gap: 16px;
}

.assessmentItemCard:hover {
    background: rgba(255, 255, 255, 0.95);
    transform: translateX(8px);
    box-shadow: 0 8px 24px rgba(245, 87, 108, 0.2);
    border-color: rgba(245, 87, 108, 0.4);
}

.assessmentItemContent {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1 1;
    min-width: 0;
}

.assessmentItemIcon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.assessmentItemIcon svg {
    font-size: 24px !important;
    color: #ffffff !important;
}

.assessmentItemInfo {
    flex: 1 1;
    min-width: 0;
}

.assessmentItemName {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 4px 0;
}

.assessmentItemHint {
    font-size: 13px;
    color: #6b7280;
    font-weight: 400;
}

.assessmentArrow {
    font-size: 18px !important;
    color: #f5576c !important;
    flex-shrink: 0;
    transition: transform 0.3s ease;
}

.assessmentItemCard:hover .assessmentArrow {
    transform: translateX(4px);
}

/* Animations */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Design */
@media (max-width: 1200px) {
    .courseModuleMainDiv {
        padding: 30px 40px;
    }
}

@media (max-width: 768px) {
    .courseModuleMainDiv {
        padding: 30px 20px;
    }

    .courseHeader {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }

    .courseIconWrapper {
        width: 60px;
        height: 60px;
    }

    .courseHeaderIcon {
        font-size: 30px !important;
    }

    .courseTitle {
        font-size: 32px;
    }

    .courseSubtitle {
        font-size: 14px;
    }

    .sectionTitle {
        font-size: 24px;
    }

    .accordionSummary {
        padding: 16px 20px !important;
    }

    .courseItemCard,
    .assessmentItemCard {
        padding: 16px;
        flex-direction: column;
        align-items: flex-start;
    }

    .courseItemContent,
    .assessmentItemContent {
        width: 100%;
    }

    .courseItemProgress {
        align-self: flex-end;
    }
}

@media (max-width: 480px) {
    .courseModuleMainDiv {
        padding: 20px 16px;
    }

    .courseBreadcrumb {
        font-size: 12px;
        flex-wrap: wrap;
    }

    .courseTitle {
        font-size: 28px;
    }

    .partNumberBadge {
        width: 36px;
        height: 36px;
        font-size: 14px;
    }

    .accordionHeading {
        font-size: 16px !important;
    }

    .courseItemName,
    .assessmentItemName {
        font-size: 14px;
    }
}

.assessmentStatusTag {
  font-size: 14px !important;   /* Increase text size */
  padding: 6px 12px !important; /* Increase tag padding */
  height: auto !important;      /* Allow larger height */
  border-radius: 8px !important; /* Optional: smoother edges */
}
`, "",{"version":3,"sources":["webpack://./src/Components/CareerProgram/CareerCourseModule/CareerCourseModule.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,oBAAoB,EAAE,yBAAyB;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,WAAW;AACX;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,gDAAgD;IAChD,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,8CAA8C;IAC9C,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,gDAAgD;IAChD,mCAA2B;YAA3B,2BAA2B;IAC3B,qDAAqD;IACrD,8BAA8B;IAC9B,oDAAoD;IACpD,8BAA8B;IAC9B,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,sDAAsD;AAC1D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI,wEAAwE;IACxE,yDAAyD;AAC7D;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,+CAA+C;AACnD;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,6DAA6D;IAC7D,+CAA+C;AACnD;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;IAC3B,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6DAA6D;IAC7D,8CAA8C;IAC9C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;;QAEI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;EACE,0BAA0B,IAAI,uBAAuB;EACrD,4BAA4B,EAAE,yBAAyB;EACvD,uBAAuB,OAAO,wBAAwB;EACtD,6BAA6B,EAAE,6BAA6B;AAC9D","sourcesContent":["/* Modern AI-Style Course Module Page */\n\n.courseModuleMainDiv {\n    min-height: calc(100vh - 80px);\n    padding: 40px 60px;\n    background: #ffffff;\n    position: relative;\n    margin-top: 60px;\n}\n\n.disabledModule {\n  filter: grayscale(100%);\n  opacity: 0.45;\n  pointer-events: none; /* block click & expand */\n  border: 1px solid #d3d3d3;\n}\n\n.comingSoonText {\n  margin-left: auto;\n  font-size: 12px;\n  color: #999;\n  font-style: italic;\n  background: rgba(255, 255, 255, 0.4);\n  padding: 3px 8px;\n  border-radius: 6px;\n}\n\n\n/* Breadcrumb Navigation */\n.courseBreadcrumb {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 30px;\n    font-size: 14px;\n    position: relative;\n    z-index: 1;\n}\n\n.breadcrumbLink {\n    color: #667eea;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 500;\n    text-decoration: none;\n    padding: 4px 8px;\n    border-radius: 6px;\n}\n\n.breadcrumbLink:hover {\n    color: #764ba2;\n    background: rgba(102, 126, 234, 0.1);\n    transform: translateY(-1px);\n}\n\n.breadcrumbCurrent {\n    color: #6b7280;\n    font-weight: 400;\n}\n\n.breadcrumbArrow {\n    font-size: 12px !important;\n    color: #9ca3af !important;\n}\n\n/* Loader */\n.courseLoader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n    position: relative;\n    z-index: 1;\n}\n\n/* Course Header */\n.courseHeader {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    margin-bottom: 40px;\n    position: relative;\n    z-index: 1;\n    animation: fadeInUp 0.6s ease-out;\n}\n\n.courseIconWrapper {\n    width: 80px;\n    height: 80px;\n    background: rgba(102, 126, 234, 0.1);\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n    flex-shrink: 0;\n    transition: all 0.3s ease;\n}\n\n.courseIconWrapper:hover {\n    transform: translateY(-5px) scale(1.05);\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);\n}\n\n.courseHeaderIcon {\n    font-size: 40px !important;\n    color: #667eea !important;\n}\n\n.courseHeaderContent {\n    flex: 1;\n}\n\n.courseTitle {\n    font-size: 42px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0 0 12px 0;\n    line-height: 1.2;\n    letter-spacing: -0.5px;\n}\n\n.courseSubtitle {\n    font-size: 16px;\n    color: #6b7280;\n    margin: 0;\n    line-height: 1.6;\n    font-weight: 400;\n}\n\n/* Section Headers */\n.courseModulesSection,\n.assessmentSection {\n    margin-bottom: 40px;\n    position: relative;\n    z-index: 1;\n    animation: fadeInUp 0.8s ease-out;\n}\n\n.sectionHeader {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.sectionIcon {\n    font-size: 28px !important;\n    color: #667eea !important;\n    background: rgba(102, 126, 234, 0.1);\n    padding: 8px;\n    border-radius: 10px;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n}\n\n.assessmentSectionIcon {\n    background: rgba(245, 87, 108, 0.1) !important;\n    border-color: rgba(245, 87, 108, 0.2) !important;\n}\n\n.sectionTitle {\n    font-size: 28px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n/* Modern Accordion */\n.modernAccordion {\n    background: rgba(255, 255, 255, 0.95) !important;\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.3) !important;\n    border-radius: 16px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;\n    margin-bottom: 16px !important;\n    overflow: hidden;\n    transition: all 0.3s ease !important;\n}\n\n.modernAccordion:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;\n}\n\n.modernAccordion::before {\n    display: none !important;\n}\n\n.accordionSummary {\n    padding: 20px 24px !important;\n    min-height: 72px !important;\n    transition: all 0.3s ease !important;\n}\n\n.accordionSummary .MuiAccordionSummary-content {\n    margin: 12px 0 !important;\n    overflow: visible !important;\n}\n\n.accordionSummary:hover {\n    background: rgba(102, 126, 234, 0.05) !important;\n}\n\n.accordionHeaderContent {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    width: 100%;\n    min-width: 0;\n    flex: 1;\n}\n\n.partNumberBadge {\n    width: 66px;\n    height: 48px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    font-weight: 700;\n    font-size: 18px;\n    flex-shrink: 0;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n    min-width: 48px;\n}\n\n.assessmentBadge {\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;\n    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4) !important;\n}\n\n.assessmentBadge svg {\n    font-size: 24px !important;\n}\n\n.accordionHeadingWrapper {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n}\n\n.accordionHeading {\n    margin: 0 !important;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    color: #1f2937 !important;\n    text-transform: none !important;\n    overflow: visible;\n    white-space: normal;\n    word-wrap: break-word;\n    line-height: 1.5;\n    display: block;\n    width: 100%;\n}\n\n.expandIcon {\n    color: #667eea !important;\n    font-size: 24px !important;\n    transition: transform 0.3s ease !important;\n}\n\n.modernAccordion[aria-expanded=\"true\"] .expandIcon {\n    transform: rotate(180deg);\n}\n\n.accordionDetails {\n    padding: 0 24px 24px 24px !important;\n    background: rgba(255, 255, 255, 0.5) !important;\n}\n\n/* Course Source Div */\n.courseSourceDiv {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n/* Course Item Card */\n.courseItemCard {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px;\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    gap: 16px;\n}\n\n.courseItemCard:hover {\n    background: rgba(255, 255, 255, 0.95);\n    transform: translateX(8px);\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);\n    border-color: rgba(102, 126, 234, 0.4);\n}\n\n.courseItemContent {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex: 1;\n    min-width: 0;\n}\n\n.courseItemIcon {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    transition: all 0.3s ease;\n}\n\n.videoIcon {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n}\n\n.documentIcon {\n    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n    box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);\n}\n\n.courseItemIcon svg {\n    font-size: 24px !important;\n    color: #ffffff !important;\n}\n\n.courseItemInfo {\n    flex: 1;\n    min-width: 0;\n}\n\n.courseItemName {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0 0 8px 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.courseItemMeta {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.courseItemTime {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 13px;\n    color: #6b7280;\n    font-weight: 500;\n}\n\n.timeIcon {\n    font-size: 16px !important;\n    color: #6b7280 !important;\n}\n\n.courseItemType {\n    padding: 4px 12px;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.typeVideo {\n    background: rgba(102, 126, 234, 0.1);\n    color: #667eea;\n}\n\n.typeDocument {\n    background: rgba(79, 172, 254, 0.1);\n    color: #4facfe;\n}\n\n.courseItemProgress {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.completedIcon {\n    position: absolute;\n    font-size: 20px !important;\n    color: #10b981 !important;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n/* Assessment Item Card */\n.assessmentItemCard {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px;\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(245, 87, 108, 0.2);\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    gap: 16px;\n}\n\n.assessmentItemCard:hover {\n    background: rgba(255, 255, 255, 0.95);\n    transform: translateX(8px);\n    box-shadow: 0 8px 24px rgba(245, 87, 108, 0.2);\n    border-color: rgba(245, 87, 108, 0.4);\n}\n\n.assessmentItemContent {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex: 1;\n    min-width: 0;\n}\n\n.assessmentItemIcon {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.assessmentItemIcon svg {\n    font-size: 24px !important;\n    color: #ffffff !important;\n}\n\n.assessmentItemInfo {\n    flex: 1;\n    min-width: 0;\n}\n\n.assessmentItemName {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0 0 4px 0;\n}\n\n.assessmentItemHint {\n    font-size: 13px;\n    color: #6b7280;\n    font-weight: 400;\n}\n\n.assessmentArrow {\n    font-size: 18px !important;\n    color: #f5576c !important;\n    flex-shrink: 0;\n    transition: transform 0.3s ease;\n}\n\n.assessmentItemCard:hover .assessmentArrow {\n    transform: translateX(4px);\n}\n\n/* Animations */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .courseModuleMainDiv {\n        padding: 30px 40px;\n    }\n}\n\n@media (max-width: 768px) {\n    .courseModuleMainDiv {\n        padding: 30px 20px;\n    }\n\n    .courseHeader {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n    }\n\n    .courseIconWrapper {\n        width: 60px;\n        height: 60px;\n    }\n\n    .courseHeaderIcon {\n        font-size: 30px !important;\n    }\n\n    .courseTitle {\n        font-size: 32px;\n    }\n\n    .courseSubtitle {\n        font-size: 14px;\n    }\n\n    .sectionTitle {\n        font-size: 24px;\n    }\n\n    .accordionSummary {\n        padding: 16px 20px !important;\n    }\n\n    .courseItemCard,\n    .assessmentItemCard {\n        padding: 16px;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .courseItemContent,\n    .assessmentItemContent {\n        width: 100%;\n    }\n\n    .courseItemProgress {\n        align-self: flex-end;\n    }\n}\n\n@media (max-width: 480px) {\n    .courseModuleMainDiv {\n        padding: 20px 16px;\n    }\n\n    .courseBreadcrumb {\n        font-size: 12px;\n        flex-wrap: wrap;\n    }\n\n    .courseTitle {\n        font-size: 28px;\n    }\n\n    .partNumberBadge {\n        width: 36px;\n        height: 36px;\n        font-size: 14px;\n    }\n\n    .accordionHeading {\n        font-size: 16px !important;\n    }\n\n    .courseItemName,\n    .assessmentItemName {\n        font-size: 14px;\n    }\n}\n\n.assessmentStatusTag {\n  font-size: 14px !important;   /* Increase text size */\n  padding: 6px 12px !important; /* Increase tag padding */\n  height: auto !important;      /* Allow larger height */\n  border-radius: 8px !important; /* Optional: smoother edges */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
